var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout", class: "md-alignment-top-center" },
    [
      _c(
        "div",
        {
          staticClass: "md-layout md-alignment-top-center",
          class: "md-alignment-top-center"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100 md-alignment-top-center"
            },
            [
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stars-wrapper" },
                [
                  _vm._l(5, function(index) {
                    return [
                      _vm.level >= index - 0.5
                        ? _c("img", {
                            key: "filled-" + index,
                            staticClass: "star",
                            attrs: {
                              src: require("../../../../assets/star.svg"),
                              alt: "Star",
                              width: _vm.size,
                              height: _vm.size
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.level < index - 0.5
                        ? _c("img", {
                            key: "gray-" + index,
                            staticClass: "star",
                            attrs: {
                              src: require("../../../../assets/star_gray.svg"),
                              alt: "Star",
                              width: _vm.size,
                              height: _vm.size
                            }
                          })
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "md-alignment-top-center",
                  staticStyle: { "text-align": "center", width: "100%" }
                },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", { staticClass: "levelSubheading" }, [
                    _vm._v("Level")
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    { staticClass: "mb-2", attrs: { id: "finalScore" } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.level + "/5") +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.levelData && _vm.levelData[_vm.level - 1]
                    ? _c("h2", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.levelData[_vm.level - 1].name) +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.levelData && _vm.levelData[_vm.level - 1] && false
                    ? _c("p", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.levelData[_vm.level - 1].text) +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.resulttoken
                    ? _c("p", [
                        _vm._v(
                          "\n                    Bitte notieren Sie sich Ihren "
                        ),
                        _c("strong", [_vm._v("Ergebniscode")]),
                        _vm._v(": "),
                        _c("br"),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.resulttoken) +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br")
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29ca7330", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ca7330","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/components/ResultCard.vue
// module id = null
// module chunks = 